import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { CheckboxInput as Input } from '@vk-hr-tek/ui/input';

/**
 * Компонент для ввода чекбокса с поддержкой react-final-form.
 *
 * @public
 * @param label - Текст метки для чекбокса.
 * @param labelIcon - Иконка для метки.
 * @param labelPlacement - Позиционирование метки относительно чекбокса.
 * @param labelColor - Цвет метки.
 * @param labelVariant - Вариант оформления метки.
 * @param name - Имя поля формы.
 * @param tooltip - Текст подсказки.
 * @param checkboxTooltip - Тултип для чекбокса.
 * @param disabled - Флаг отключения чекбокса.
 * @param onChange - Функция для обработки изменения состояния чекбокса.
 * @param testId - Идентификатор для тестирования.
 * @returns Компонент ввода чекбокса.
 */
export const CheckboxInput = ({
  label,
  labelIcon,
  labelPlacement,
  labelColor,
  labelVariant,
  name,
  tooltip,
  checkboxTooltip,
  disabled,
  onChange,
  testId,
  ...rest
}: FieldProps<boolean | undefined, FieldRenderProps<boolean | undefined>>) => (
  <Field name={name} {...rest}>
    {({ input }) => (
      <Input
        {...input}
        label={label}
        labelIcon={labelIcon}
        labelPlacement={labelPlacement}
        labelColor={labelColor}
        labelVariant={labelVariant}
        checked={input.value}
        tooltip={tooltip}
        checkboxTooltip={checkboxTooltip}
        disabled={disabled}
        onChange={onChange || input.onChange}
        testId={testId}
      />
    )}
  </Field>
);
